export default "__VITE_ASSET__2M_DcFAr__"